import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.css'],
    imports: [
    FaIconComponent,
    NgbTooltip,
    FormsModule
]
})
export class ToggleComponent {

  @Input() iconLeft: string;
  @Input() iconRight: string;

  @Input() tooltipLeft: string;
  @Input() tooltipRight: string;

  @Input() backgroundColor: string;

  @Input()
  enabled = true;
  @Output()
  enabledChange = new EventEmitter<boolean>();

  changeValue(value: boolean): void {
    this.enabledChange.emit(value);
  }
}
